import React, { useEffect, useState } from 'react'
import dayjs from 'shared/dayjs'
import DatePicker from '../../../../../components/common/date-time-pickers/DatePicker'
import { css } from '@emotion/react'
import { feEnrolmentTimingsFilterEnum } from 'front-end/src/pages/manage-campaign-page/components/campaign-audience/CampaignAudienceHelpers'
import { TemporalDirection } from 'front-end/src/graphql/private/PrivateSchemaTypes'
import { useEditCampaignFilterContext } from 'front-end/src/pages/manage-campaign-page/components/campaign-audience/modals/enrolment-modal/EditCampaignFilterContext'

export const EditCampaignFilterStaticDate = ({
  setTemporalComparator,
  selectedEnrolmentTimingType
}) => {
  const { editedFilter } = useEditCampaignFilterContext()
  const [date, setDate] = useState(() =>
    dayjs(editedFilter.temporalComparator?.static?.date)
      .startOf('day')
      .toISOString()
  )

  useEffect(() => {
    setTemporalComparator({
      static: {
        ...editedFilter.temporalComparator?.static,
        date,
        direction:
          selectedEnrolmentTimingType ===
          feEnrolmentTimingsFilterEnum.BEFORE_DATE
            ? TemporalDirection.BEFORE
            : TemporalDirection.AFTER
      }
    })
  }, [date, selectedEnrolmentTimingType])

  return (
    <DatePicker
      css={css`
        max-width: 424px;
      `}
      value={date ? dayjs(date).format('L') : ''}
      onChange={(value) => {
        setDate(dayjs(value.toString()).toISOString())
      }}
    />
  )
}
